module.exports = __webpack_public_path__ + "img/proList2_27_12.eb718c23.jpg";